//import liraries
import React  from 'react';
import { View, StyleSheet, TextInput, Dimensions } from 'react-native';

// create a component

const isSmallDevice = Dimensions.get('window').width < 767
const CustomTextInput = (props) => {

    const changeText = (t) =>{
        if(props.type == 'number'){
            if(!isNaN(t))
                props.onChangeText(t)
        }else
           props.onChangeText(t)  
    }
    return (
        <View style={styles.textInputContainerStyle}>
            <TextInput
                value={props.value}
                onChangeText={(t)=>changeText(t)}
                style={props.style ? props.style :styles.textInputStyle}
                placeholder={props.placeholder}
                secureTextEntry={props.secureTextEntry}
                maxLength={props.maxLength}
                autoCapitalize ={props.autoCapitalize}
                autoComplete ="off"
                textContentType = "none"
                importantForAutofill="no"
            />
        </View>
    );
};

// define your styles
const styles = StyleSheet.create({
    container: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#2c3e50',
    },
    textInputContainerStyle: {
        width: "100%",
        height: 40,
        borderRadius: 6.6,
        borderStyle: "solid",
        borderWidth: 1,
        borderColor: "#cccccc",
        alignSelf: "center",
        backgroundColor: "#ffffff",
        fontFamily:"Inter" 
    },
    textInputStyle: {
        width: "100%",
        height: 40,
        fontFamily: "Inter",
        fontSize: 13,
        fontWeight: "bold",
        fontStyle: "normal",
        lineHeight: 15,
        letterSpacing: -0.26,
        textAlign: "left",
        color: "#6e6e6e",
        paddingLeft: 10,
    },
});

//make this component available to the app
export default CustomTextInput;
